export const DEFAULT_VALUES = {
    coder_a: {
        width: 470,
        height: 875,
        left: 30,
        right: Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0),
    },
    coder_b: {
        width: 470,
        height: 875,
        left: 530,
        right: Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0),
    },
    coder_qa: {
        width: 470,
        height: 875,
        left: 0,
        right: Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0) - 290,
    },
};

export const OFFSET = {
    x: 275,
    y: 100,
};

export const SCREEN_BORDERS = {
    TOP: -75,
    LEFT: 15,
};

export const setInitialPos = (popoutRef, roleType) => {
    const isQA = roleType === "qa";
    const wRect = DEFAULT_VALUES[`coder_${roleType}`];
    popoutRef.current.style.transform = `translateX(${isQA ? wRect.right : wRect.left}px)`;
};
